<template>
  <basic-container>
    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :permission="permissionList"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template slot="menuLeft"> </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { mapGetters } from "vuex";
import { getChronicDisease } from "@/api/health/manage";

export default {
  data() {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        tip: false,
        border: true,
        // index: true,
        viewBtn: true,
        editBtn: false,
        addBtn: false,
        delBtn: false,
        menu: false,
        // selection: true,
        column: [
          {
            label: "消化系统",
            prop: "digestion",
            // search: true
          },
          {
            label: "呼吸系统",
            prop: "breath",
            // search: true
          },
          {
            label: "心脑血管系统",
            prop: "cardiovascular",
            // search: true
          },
          {
            label: "内分泌代谢系统",
            prop: "metabolic",
          },
          // {
          //   label: "代谢系统",
          //   prop: "heartRate",
          // },
          {
            label: "神经系统",
            prop: "nervous",
          },
          {
            label: "骨关节",
            prop: "joint",
          },
          {
            label: "运动系统",
            prop: "move",
          },
          {
            label: "泌尿系统",
            prop: "urinate",
          },
          {
            label: "生殖系统",
            prop: "reproduction",
          },
          {
            label: "心理障碍",
            prop: "psychology",
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },
  methods: {
    onLoad() {
      const wxUserId = this.$route.query.wxUserId;
      getChronicDisease(wxUserId).then((res) => {
        this.data = res.data;
      });
    },
  },
};
</script>
